module.exports = "<section class=\"dop-menu-top dop-menu-top--small\" *ngIf='!!campaign'>\n  <div class=\"row rowbonus\">\n    <div class=\"small-10 columns clearfix\">\n      <ul class=\"menu\">\n        <li *ngFor = \"let selected of actives\">\n          <a [ngClass]=\"{'active' : active == selected}\"\n             [routerLink] =\"['/campaigns', campaign.id, selected]\">\n             {{ 'campaigns.actionmenu.' + selected | translate }}\n          </a>\n        </li>\n      </ul>\n    </div>\n  </div>\n</section>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/campaigns/components/campaign-menu.component.html
// module id = 359
// module chunks = 0